import { Dialog } from "primereact/dialog";
import React from "react";

const GlobalDialog = ({
  children,
  closable,
  dialogClassName,
  visible,
  onHide,
  dialogHeader,
  draggable = false,
  footer,
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={dialogHeader}
      closable={closable}
      //         className="max-w-[95%] md:w-[700px]"
      className={`${
        dialogClassName !== ""
          ? `${dialogClassName}`
          : "max-w-[95%] md:w-[700px]"
      } z-[9999999] font-montserrat text-secondary-purpleGray mx-5`}
      draggable={draggable}
      style={{ zIndex: 500000 }}
      resizable={false}
      footer={footer}
    >
      {children}
    </Dialog>
  );
};

export default GlobalDialog;
